import { ArrowRightIcon, PuzzlePieceIcon } from '@heroicons/react/24/solid'
import { ClockIcon } from '@heroicons/react/24/outline'
const StoryCard = ({ data }) => {
    const {
        id,
        titulo,
        portada,
        ilustraciones,
        descripcion,
        dificultad,
        tiempoLectura
    } = data;

    const handleClick = () => {
        window.location.href = `/cuentos/${id}`;
    };

    const imageUrl = ilustraciones && ilustraciones.length > 0
        ? `${process.env.REACT_APP_BACKEND_URL}/api/cuentos/ilustraciones/${portada}`
        : null;

    return (
        <div onClick={handleClick} className="bg-pearl-50 rounded-2xl shadow-lg hover:shadow-xl overflow-hidden hover:cursor-pointer hover:scale-105 transform transition-all duration-300 border border-pearl-200">
            {imageUrl ? (
                <img
                    className="w-full h-auto aspect-square object-cover"
                    src={imageUrl}
                    alt={titulo}
                    draggable="false"
                />
            ) : (
                <div className="w-full h-[200px] bg-pearl-200 flex items-center justify-center text-charcoal-500">
                    📖 Sin imagen
                </div>
            )}

            <div className="px-6 py-4 h-[220px] md:h-[200px]">
                <div className="font-bold text-xl mb-3 text-japanese-ink font-japanese">{titulo}</div>
                <p className="text-charcoal-600 text-base leading-relaxed">
                    {descripcion}
                </p>
            </div>
            <div className="px-6 pt-4 pb-6 flex justify-center flex-col md:flex-row text-center">
                <div className="inline-block bg-sage-100 border border-sage-200 rounded-full px-3 py-1 text-sm font-semibold text-sage-700 mr-2 mb-2">
                    <ClockIcon className="inline-block h-5 w-5 mb-1 mr-1" />
                    <span className="inline-block">{tiempoLectura} min.</span>
                </div>
                <div className="inline-block bg-primary-100 border border-primary-200 rounded-full px-3 py-1 text-sm font-semibold text-primary-700 mr-2 mb-2">
                    <PuzzlePieceIcon className="inline-block h-5 w-5 mb-1 mr-1" />
                    {dificultad}
                </div>
                <div className='inline-block bg-japanese-paper hover:bg-pearl-200 border border-charcoal-200 hover:border-primary-300 rounded-full px-3 py-1 text-sm font-semibold text-charcoal-700 hover:text-primary-700 transition-all duration-200 hover:cursor-pointer mr-1 mb-2'>
                    <span className="inline-block">Leer <ArrowRightIcon className="inline-block h-5 w-5 mb-1" /></span>
                </div>
            </div>
        </div>
    );
};

export default StoryCard;